import { Helmet } from 'react-helmet';

export const getCurrentDate = (separator='-') => {
    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date<10?`0${date}`:`${date}`}`
}

export const HelmetWrapper = ({ title, description, url }) => {
    return (
        <Helmet>
            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title || "JudgeAutos – Car Show Management Web App"} />
            <meta property="og:description" content={description || "A web-based app for managing car show participants, registration, judging, and results, making shows more efficient and organized."} />
            <meta property="og:url" content={url ? `https://judgeautos.com/${url}` : "https://judgeautos.com"} />

            {/* Other Meta Tags */}
            <title>{title || "JudgeAutos – Web-based Car Show App"}</title>
            <meta
                name="description"
                content={
                    description ||
                    "JudgeAutos is a web app for managing car show participants, registration, judging, results, and overall event organization."
                }
            />
        </Helmet>
    )
}